import { render, staticRenderFns } from "./accountDescribe.vue?vue&type=template&id=051d4fa2&scoped=true&"
import script from "./accountDescribe.vue?vue&type=script&lang=js&"
export * from "./accountDescribe.vue?vue&type=script&lang=js&"
import style0 from "./accountDescribe.vue?vue&type=style&index=0&id=051d4fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d4fa2",
  null
  
)

export default component.exports